// delete-confirmation-modal.component.ts
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DeleteConfirmationModalData {
  title: string;
  entityName: string;
  entityDetails: { [key: string]: string };
  warningMessage: string;
  relatedItems: string[];
  confirmationText?: string;
  isDestructive?: boolean;
}

export interface DeleteConfirmationModalResult {
  confirmed: boolean;
  reason?: string;
}

@Component({
  selector: 'app-delete-confirmation-modal',
  templateUrl: './delete-confirmation-modal.component.html',
  styleUrls: ['./delete-confirmation-modal.component.css']
})
export class DeleteConfirmationModalComponent {
  form: FormGroup;
  confirmationText: string;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<DeleteConfirmationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteConfirmationModalData
  ) {
    this.confirmationText = this.data.confirmationText || 'ELIMINAR';

    this.form = this.fb.group({
      reason: [''],
      confirmation: ['', [Validators.required, this.confirmarEliminacionValidator.bind(this)]]
    });
  }

  confirmarEliminacionValidator(control: any) {
    const value = control.value?.toUpperCase();
    return value === this.confirmationText.toUpperCase() ? null : { confirmacionIncorrecta: true };
  }

  onConfirm(): void {
    if (this.isFormValid()) {
      const result: DeleteConfirmationModalResult = {
        confirmed: true,
        reason: this.form.get('reason')?.value || ''
      };
      this.dialogRef.close(result);
    }
  }

  onCancel(): void {
    const result: DeleteConfirmationModalResult = {
      confirmed: false
    };
    this.dialogRef.close(result);
  }

  isFormValid(): boolean {
    return this.form.valid;
  }

  get confirmacionControl() {
    return this.form.get('confirmation');
  }
}
